import { render, staticRenderFns } from "./Modal-3.vue?vue&type=template&id=fea6f254&scoped=true&"
import script from "./Modal-3.vue?vue&type=script&lang=js&"
export * from "./Modal-3.vue?vue&type=script&lang=js&"
import style0 from "./Modal-3.vue?vue&type=style&index=0&id=fea6f254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea6f254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fea6f254')) {
      api.createRecord('fea6f254', component.options)
    } else {
      api.reload('fea6f254', component.options)
    }
    module.hot.accept("./Modal-3.vue?vue&type=template&id=fea6f254&scoped=true&", function () {
      api.rerender('fea6f254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/modal/Modal-3.vue"
export default component.exports